import { Container, Grid, GridItem, Heading } from '@chakra-ui/react';
import LargeCard from './LargeCard';

export default function LargeCards({
  title,
  cards,
  size = 2,
}: {
  title?: string;
  cards: {
    image: {
      sourceUrl: string;
      altText: string;
    };
    title: string;
    text: string;
    button?: {
      type: string;
      text: {
        strong: string;
        normal: string;
      };
      url: string;
      target?: string;
    };
  }[];
  size?: number;
}) {
  return (
    <Container my={{ base: '12', lg: '24' }}>
      {title && (
        <Heading
          as="h2"
          fontSize={{ base: '2rem', lg: '2.625rem' }}
          lineHeight={{ base: '2.25rem', lg: '3rem' }}
          textAlign="center"
          mb={{ base: '12', lg: '14' }}
        >
          {title}
        </Heading>
      )}
      <Grid
        gap={{
          base: '24',
          lg: `${size === 2 ? '6.875' : '3'}rem`,
          xl: `${size === 2 ? '13.75' : '3'}rem`,
        }}
        gridTemplateColumns={{ lg: `repeat(${size}, 1fr)` }}
      >
        {cards.map((card, index, { length }) => (
          <GridItem key={card.title}>
            <LargeCard card={card} index={index} length={length} />
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
}
